import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MmpAiSummaryComponent } from "../mmp-ai-summary/mmp-ai-summary.component";

@Component({
  selector: "app-mmp-loader",
  templateUrl: "./mmp-loader.component.html",
  styleUrls: ["./mmp-loader.component.scss"],
  standalone: true,
  imports: [CommonModule, MmpAiSummaryComponent],
})
export class MmpLoaderComponent {
  // give each array a unique, stable value per index
  rows = Array.from({ length: 4 }, (_, i) => i);
  cols = Array.from({ length: 3 }, (_, i) => i);
  totalLoader = Array.from({ length: 5 }, (_, i) => i);

  progressTagMsg: string = "In progress";

  @Input() progressTimeText!: string;
}
